import { Dropdown } from 'common/form';
import { rulesetInputWidth } from 'modules/analyse/components/RuleSettingItem';
import { getStatusOptions } from 'modules/analyse/utils/getStatusOptions';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';
import { useRecoilValue } from 'recoil';
import { statusSetAtom } from 'services/candidate/atoms';

type RuleSettingAnalysisAutomationItemProps = {
  analysisAutomationItem: AutomationFormItem;
  onChangeAnalysisAutomationItem: (value: AutomationFormItem) => void;
};

export const RuleSettingAnalysisNotMetAutomationItem = ({
  analysisAutomationItem,
  onChangeAnalysisAutomationItem
}: RuleSettingAnalysisAutomationItemProps) => {
  const statusSet = useRecoilValue(statusSetAtom);

  const handleChangeCandidateStatus = (value: string) => {
    onChangeAnalysisAutomationItem({
      ...analysisAutomationItem,
      action: {
        ...analysisAutomationItem.action,
        candidateStatus: value
      }
    });
  };

  return (
    <Dropdown
      field={{
        containerSx: { width: rulesetInputWidth },
        label:
          "When knockout requirements have not been met, change the applicant's status to",
        options: getStatusOptions({ statusSet })
      }}
      value={analysisAutomationItem.action.candidateStatus || ''}
      onChange={handleChangeCandidateStatus}
    />
  );
};
